import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getEnrichedArticles } from "../../shared/utils/getArticleInformation"
import { getCustomer } from "../../shared/utils/getCustomer"
import { groqProductProjection } from "../sanity/product.projection"
import { filterOutArticlesNotAvailableInBranchOffice } from "../utils/filters"

export const queryProduct = {
  async product(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, key, customerId, loggedInBranch } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.PRODUCTS,
      operation: Operations.READ,
    })

    if (!key) return null

    if (customerId) {
      const customer = await getCustomer({ id: customerId })

      await validateAccessRightsToCustomer({
        user: user,
        customerNumber: customer.customerNumber,
      })
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    let product
    product = await client.fetch(
      groq`*[_type=="product" && key==$key ${draftsFilter}][0] {
        ...,
        ${groqProductProjection()}
      }`,
      { key: key },
    )

    product = {
      ...product,
    }

    if (product.variants) {
      if (loggedInBranch) {
        product.variants = filterOutArticlesNotAvailableInBranchOffice(product.variants, loggedInBranch)
      }

      product.variants = await getEnrichedArticles({
        context,
        articles: product.variants,
        branchId: loggedInBranch,
        customerNumber: null,
        customerId: customerId,
        productKey: key,
      })
    }
    product.categories = product.categories || []
    product.similarProducts = product.similarProducts || []
    product.attributes =
      product?.attributes?.map((attr) => ({
        id: attr?.attribute?.id,
        key: attr?.attribute?.key,
        value: attr?.value,
      })) || []

    product.variants = product.variants.filter((v) => v !== null)
    product.categories = product.categories.filter((c) => c !== null)
    product.similarProducts = product.similarProducts.filter((sp) => sp !== null)
    product.attributes = product.attributes.filter((attr) => attr !== null)

    if (typeof product?.modifiedAt === "string") {
      product.modifiedAt = new Date(product.modifiedAt)
    }

    return product
  },
}
